














import {
  PreCollectionSortBy,
  PreCollectionSortByFriendlyValue,
  preCollectionSortByList,
} from '@/resource/pre-collection/pre-collection.model';
import { PreCollectionsParams } from '@/resource/pre-collection/pre-collection.store';
import { Component, Prop, Vue } from 'vue-property-decorator';
import FilterDropdown from '@/main-components/pre-collections-new/pre-collection-filter/FilterDropdown.vue';
import getEnumValue from '@/utils/common/get-enum-value';

@Component({
  components: {
    FilterDropdown,
  },
})
export default class FilterSortBy extends Vue {
  @Prop({ required: true })
  queries!: PreCollectionsParams;

  sortBys: string[] = preCollectionSortByList;

  getSortBy(sortBy: PreCollectionSortBy) {
    return getEnumValue(sortBy, PreCollectionSortByFriendlyValue);
  }

  updateSortBy(sortBy: PreCollectionSortBy) {
    this.queries.sortBy = sortBy;
    this.$emit('submitFilter');
  }
}
